export default "__VITE_ASSET__KeI1zSHW__"